import React, { useEffect } from 'react';
import styles from './AtendimentoRestrito.module.css';
import TituloAssociado from '../Helper/TituloAssociado';
import Head from '../Helper/Head';
import { Link } from 'react-router-dom';
import { useAssociadoContext } from '../../useAssociadoContext';
import { GET_CONVENIOS } from '../../api';
import { useUserContext } from '../../UserContext';

const AtendimentoRestrito = () => {
  const { convenios, setConvenios } = useAssociadoContext();
  const { token } = useUserContext();

  useEffect(() => {
    async function getConvenios() {
      const { url, options } = GET_CONVENIOS(token);
      const response = await fetch(url, options);
      const data = await response.json();
      if (!response.ok) throw new Error('Erro no get convenios.')
      setConvenios(data);
    }
    getConvenios()
  }, [])

  return (
    <section className={`${styles.containerPrincipal} animeLeft`}>
      <TituloAssociado titulo="CONVÊNIOS COM ATENDIMENTO RESTRITO A ASSOCIADOS DO HOSPITAL ANCHIETA" especialidade='para saber o convênio que pode ser atendido entre na relação de especialidade desejada'/>
      <Head
        title="Área do Associado - Atendimento Restrito Hosp. Anchieta"
        description="Área do associado"
      />
      <div className={styles.divConvenios}>
        {convenios && convenios?.map((item: any, index) => (
          item.restrito === true ?
            <Link to={`/area-associado/convenios/${item.id}`} key={index}>{item.nome}</Link> : null
        ))}
      </div>
    </section>
  );
};

export default AtendimentoRestrito;
